/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Selection_Options_Aria_LabelInputs */

const en_paste_attributes_selection_options_aria_label = /** @type {(inputs: Paste_Attributes_Selection_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selection options`)
};

const fr_paste_attributes_selection_options_aria_label = /** @type {(inputs: Paste_Attributes_Selection_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options de selection`)
};

const de_paste_attributes_selection_options_aria_label = /** @type {(inputs: Paste_Attributes_Selection_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahlmöglichkeiten`)
};

const it_paste_attributes_selection_options_aria_label = /** @type {(inputs: Paste_Attributes_Selection_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni di selezione`)
};

const ru_paste_attributes_selection_options_aria_label = /** @type {(inputs: Paste_Attributes_Selection_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Варианты выбора`)
};

const es_paste_attributes_selection_options_aria_label = /** @type {(inputs: Paste_Attributes_Selection_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de selección`)
};

const zh_cn2_paste_attributes_selection_options_aria_label = /** @type {(inputs: Paste_Attributes_Selection_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择选项`)
};

const ja_paste_attributes_selection_options_aria_label = /** @type {(inputs: Paste_Attributes_Selection_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択オプション`)
};

const hi_paste_attributes_selection_options_aria_label = /** @type {(inputs: Paste_Attributes_Selection_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयन विकल्प`)
};

const pt_pt2_paste_attributes_selection_options_aria_label = /** @type {(inputs: Paste_Attributes_Selection_Options_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções de seleção`)
};

/**
* | output |
* | --- |
* | "Selection options" |
*
* @param {Paste_Attributes_Selection_Options_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_selection_options_aria_label = /** @type {((inputs?: Paste_Attributes_Selection_Options_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Selection_Options_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_attributes_selection_options_aria_label(inputs)
	if (locale === "de") return de_paste_attributes_selection_options_aria_label(inputs)
	if (locale === "it") return it_paste_attributes_selection_options_aria_label(inputs)
	if (locale === "ru") return ru_paste_attributes_selection_options_aria_label(inputs)
	if (locale === "es") return es_paste_attributes_selection_options_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_attributes_selection_options_aria_label(inputs)
	if (locale === "ja") return ja_paste_attributes_selection_options_aria_label(inputs)
	if (locale === "hi") return hi_paste_attributes_selection_options_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_attributes_selection_options_aria_label(inputs)
	return en_paste_attributes_selection_options_aria_label(inputs)
});